import { createClient } from '@supabase/supabase-js';
import { Session, User } from '@supabase/supabase-js';


export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_ANON_KEY!
);

export async function getSessionInfo(): Promise<{ session: Session | null; user: User | null }> {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw new Error(`Error fetching session: ${error.message}`);
    return { session: data.session, user: data.session?.user ?? null };
  }


export async function getAccessToken(): Promise<string> {
    // Mock token for offline development
    if (process.env.REACT_APP_MOCK_AUTH === 'true') {
      return 'MOCK_TOKEN';
    }
    
    const { session } = await getSessionInfo();
    const token = session?.access_token;
    if (!token) throw new Error('No access token available');
    return token;
  }

export async function signOut(): Promise<void> {
    const { error } = await supabase.auth.signOut({ scope: 'local' });
    
    if (error) throw new Error(`Error signing out: ${error.message}`);
}